export { default as LsGrid } from './LSGrid.vue';
export type { LSProps } from './LSGrid';